// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

import Vue from 'vue'
import Vuex from 'vuex'

import images from 'photoservice-web/src/store/modules/images.js'
import selectors from './modules/selectors'
import user from './modules/user'
import settings from './modules/settings'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    images,
    selectors,
    user,
    settings
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js